import { Select as MuiSelect } from '@mui/material';
import { SelectMenuItem } from '@/components/@IntranetLibrary/Select/styles';
import { CurrencyFlag, CurrencyLabel } from '@/components/Common/CurrencyFlag';
import CheckIcon from '@/public/icons/approval/check.svg';
import ChevronDownIcon from '@/public/icons/approval/chevron-down.svg';
import {
  approvalCurrencyMenuPaperSx,
  approvalCurrencySelectSx,
  CurrencyOption,
} from './styles';

export type CurrencyOptionItem = { value: string; label: string };

// 화살표는 값 옆에 붙임(레거시) — MUI 기본 아이콘은 오른쪽 끝 고정이라 숨김
const EmptyIcon = () => null;

type ApprovalTableCurrencySelectProps<T extends string> = {
  value: T;
  options: readonly { value: T; label: string }[];
  onChange: (next: T) => void;
};

/** 표 셀 통화 선택 — 국기 + 코드, 메뉴는 국기·코드·통화명·체크(레거시 custom-select) */
const ApprovalTableCurrencySelect = <T extends string>({
  value,
  options,
  onChange,
}: ApprovalTableCurrencySelectProps<T>) => (
  <MuiSelect
    className="approval-table-currency-select"
    value={value}
    onChange={(e) => onChange(e.target.value as T)}
    IconComponent={EmptyIcon}
    renderValue={(selected) => (
      <>
        <CurrencyLabel currency={selected as string} />
        <ChevronDownIcon className="arrow" />
      </>
    )}
    sx={approvalCurrencySelectSx}
    MenuProps={{ PaperProps: { sx: approvalCurrencyMenuPaperSx } }}
  >
    {options.map((option) => (
      <SelectMenuItem key={option.value} value={option.value}>
        <CurrencyOption>
          <span className="content">
            <CurrencyFlag currency={option.value} size={30} />
            <span className="name">
              <strong>{option.value}</strong>
              <small>{option.label}</small>
            </span>
          </span>
          <CheckIcon className="check" />
        </CurrencyOption>
      </SelectMenuItem>
    ))}
  </MuiSelect>
);

export default ApprovalTableCurrencySelect;
